<template>
  <v-toolbar flat color="transparent">
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nuevo"
      iconText="mdi-plus"
      tipo="agregar"
      @click="registrarAnticipo">
    </custom-button>
  </v-toolbar>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AnticiposToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    registrarAnticipo() {
      this.$emit('registrarAnticipo');
    },
  },
};
</script>

<style lang="scss">

</style>
